module.exports = __webpack_public_path__ + "static/BigBang_UAU_NSZ-c5d1423d54b0b3131c54b032b5485503.mp4";